import axios from 'axios'
import { useState } from 'react'
import type { SearchParamsAttributes } from '@pc/components/Works/Panel/types'
import { buildWorkCountApiUrl } from '@pc/components/Works/Panel/utils/workSearchApi'

const useWorksCount = () => {
  const [worksCount, setWorksCount] = useState(0)

  const updateCountFromParams = (mergedParams: SearchParamsAttributes) => {
    const endPoint: string = buildWorkCountApiUrl(mergedParams)
    axios
      .get(endPoint)
      .then((res) => {
        setWorksCount(res.data as number)
      })
      .catch((err) => {
        console.log(err.message)
      })
  }

  return { worksCount, updateCountFromParams }
}

export default useWorksCount
